import { render } from "./ToastComponent.vue?vue&type=template&id=b38dfe70&scoped=true&ts=true"
import script from "./ToastComponent.vue?vue&type=script&lang=ts"
export * from "./ToastComponent.vue?vue&type=script&lang=ts"

import "./ToastComponent.vue?vue&type=style&index=0&id=b38dfe70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38dfe70"]])

export default __exports__